// This component is used by TableView, dont use it directly
// To create sidebar content use TableSidebar component
import React from 'react';
import PropTypes from 'prop-types';
import { useResponsive } from '../../../services/hooks';
import { Drawer, Box } from '@mui/material';
import { NAVBAR } from '../../../utils/config';
import Scrollbar from '../../../components/Scrollbar';


const TableSidebarDrawer = ({ actionsComponent, filterComponent, isOpen, onClose }) => {
  const isDesktop = useResponsive('up', 'md');

  return <>
    {isDesktop ? (
      <Drawer variant="permanent" PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH + 20, position: 'relative', display: 'flex', flexDirection: 'column' } }}>
        <Scrollbar>
          {actionsComponent}
          <Box sx = {{ padding: 1 }} >
            {filterComponent}
          </Box>
        </Scrollbar>
      </Drawer>
    ) : (
      <Drawer
        open={isOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH }, display: 'flex', flexDirection: 'column' }}
      >
        <Scrollbar>
          {actionsComponent}
          <Box sx = {{ padding: 3 }} >
            {filterComponent}
          </Box>
        </Scrollbar>
      </Drawer>
    )}
  </>;
};

TableSidebarDrawer.propTypes = {
  actionComponent: PropTypes.node,
  filterComponent: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default TableSidebarDrawer;
